import React from 'react';
import TimesheetItem from './TimesheetItem';

function TimesheetList({ timesheets, onSelect, selectedId }) {
    return (
        <div className="timesheet-list">
            {timesheets.map((item) => (
                <TimesheetItem
                    key={item.id}
                    timesheet={item}
                    isSelected={item.id === selectedId}
                    onClick={() => onSelect(item)}
                />
            ))}
        </div>
    );
}

export default TimesheetList;
